import { Link } from "react-router-dom";
import { money, unitPriceAt, GRID_QTYS, MAX_QTY } from "./boxUtils";

export default function PriceGrid({ product, sizeKey, printKey, qty, onPick }) {
  const pm = product.price_matrix;
  const cell = `${sizeKey}|${printKey}`;
  if (!pm?.cells?.[cell]) return null;
  const size = product.sizes.find((s) => s.key === sizeKey);
  const print = product.color_options.find((o) => o.key === printKey);
  return (
    <div className="bg-white border border-slate-200" data-testid="box-price-grid">
      <div className="px-5 py-4 border-b border-slate-200 flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="font-heading text-lg font-bold text-kolt-slate">Quantity pricing</h3>
        <span className="text-xs font-mono text-slate-500">{size?.name} · {print?.name}</span>
      </div>
      <table className="data-table">
        <thead>
          <tr><th>Quantity</th><th className="text-right">Unit price</th><th className="text-right hidden sm:table-cell">Total</th></tr>
        </thead>
        <tbody>
          {GRID_QTYS.map((q) => {
            const u = unitPriceAt(pm, cell, q);
            const active = q === qty;
            return (
              <tr key={q} onClick={() => onPick(q)} data-testid={`price-grid-row-${q}`}
                className={`cursor-pointer transition-colors ${active ? "bg-orange-50" : "hover:bg-slate-50"}`}>
                <td className="font-mono">{q}{active && <span className="badge-accent ml-2">selected</span>}</td>
                <td className="text-right font-semibold text-kolt-slate">{money(u)}</td>
                <td className="text-right hidden sm:table-cell text-slate-500">{money(u * q)}</td>
              </tr>
            );
          })}
          <tr className="bg-kolt-slate-dark text-white" data-testid="price-grid-quote-row">
            <td className="font-mono">{MAX_QTY}+</td>
            <td colSpan={2} className="text-right">
              <Link to={`/quote?product=${product.slug}`} className="font-mono text-xs uppercase tracking-wider text-kolt-orange hover:underline" data-testid="price-grid-quote-link">
                Request a custom quote →
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
      <p className="px-5 py-3 text-xs text-slate-500 border-t border-slate-200">Unit price drops steadily with quantity. Click a row to set that quantity.</p>
    </div>
  );
}
